import { useEffect, useState } from 'react';
import * as Dialog from '@radix-ui/react-dialog';

// Global provenance handler. Any element with a `data-provenance`
// attribute is treated as a hover-explainable value — click pops a
// small modal showing the methodology chain. Mount once at app root.
//
// The handler attaches at document level so newly-rendered figures
// pick it up without needing per-component wiring.

export function ProvenanceModal() {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState('');

  useEffect(() => {
    function onClick(e: MouseEvent) {
      const target = e.target as HTMLElement | null;
      if (!target) return;
      const el = target.closest<HTMLElement>('[data-provenance]');
      if (!el) return;
      const v = el.dataset['provenance'];
      if (!v) return;
      e.preventDefault();
      setText(v);
      setOpen(true);
    }
    document.addEventListener('click', onClick);
    return () => document.removeEventListener('click', onClick);
  }, []);

  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Portal>
        <Dialog.Overlay
          style={{
            position: 'fixed',
            inset: 0,
            background: 'var(--bg-overlay)',
            zIndex: 1499,
          }}
        />
        <Dialog.Content
          aria-describedby={undefined}
          style={{
            position: 'fixed',
            top: '25%',
            left: '50%',
            transform: 'translateX(-50%)',
            width: '460px',
            maxWidth: '90vw',
            background: 'var(--surface)',
            border: '1px solid var(--hairline)',
            borderRadius: 2,
            zIndex: 1500,
            padding: 'var(--s-4)',
          }}
        >
          <Dialog.Title
            style={{
              margin: 0,
              marginBottom: 'var(--s-2)',
              fontSize: 'var(--t-section)',
              fontWeight: 600,
              color: 'var(--text-primary)',
              textTransform: 'uppercase',
              letterSpacing: '0.04em',
            }}
          >
            Provenance
          </Dialog.Title>
          <p
            style={{
              margin: 0,
              fontSize: 'var(--t-body)',
              color: 'var(--text-secondary)',
              lineHeight: 'var(--line-body)',
            }}
          >
            {text}
          </p>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
